import { Grid, Typography } from '@mui/material';
import MonthSelect from './month-select/month-select.component';
import DaySelect from './day-select/day-select.component';
import CustomInput from 'components/custom-input/custom-input.component';
import { useSelector } from 'react-redux';
import { selectIsDateOfBirthMandatory } from 'redux/config/config.selectors';
import { useTranslation } from 'react-i18next';

const BirthMonthDaySelect = ({ disableUpdate }) => {
  const { t } = useTranslation();
  const isDateOfBirthRequired = useSelector(selectIsDateOfBirthMandatory);

  return (
    <CustomInput>
      <Grid container>
        <Grid item xs={5}>
          <MonthSelect
            required={isDateOfBirthRequired}
            disableUpdate={disableUpdate}
          />
        </Grid>
        <Grid item xs={2} />
        <Grid item xs={5}>
          <DaySelect
            required={isDateOfBirthRequired}
            disableUpdate={disableUpdate}
          />
        </Grid>
      </Grid>
      {disableUpdate ? (
        <Typography variant="caption">
          {t('forms.dateOfBirth.updateText')}
        </Typography>
      ) : null}
    </CustomInput>
  );
};

export default BirthMonthDaySelect;
